skrilla.directive('queryWithdrawals', function () {
    return {
        templateUrl: 'directives/queryWithdrawals/queryWithdrawals.html',
        scope: {
            withdrawals: "=",
            key: "=",
            queryKey: "=",
            queryOverrides: "="
        },
        controller: async function ($scope,
                                    searchService,
                                    queryService,
                                    paginationService,
                                    cacheService,
                                    sportService,
                                    currencyService,
                                    constantsService) {
            $scope.queryOverrides = $scope.queryOverrides || {};
            $scope.currencies = currencyService.getCurrencies();
            $scope.queryKey = $scope.queryKey || "queryWithdrawals";
            $scope.marketingCategories = constantsService.getMarketingCategories();
            $scope.sortBy = {
                CREATED_AT: 'Created At',
                UPDATED_AT: 'Updated At',
                PAID_OUT: 'Paid out',
                POTENTIAL_PAYOUT: 'Potential Payout',
                STAKE: 'Stake'
            }
            $scope.totalBets = 0
            $scope.betLimit = 100000

            $scope.overrideKeys = function () {
                for(const [key, value] of Object.entries($scope.queryOverrides)){
                    $scope.query[key] = value;
                }
            }
            $scope.reset = function () {
                const currencies = currencyService.getCurrencyMap();
                if ($scope.userId) {
                    //if we have a user id return all their deposits
                    Object.keys(currencies).forEach(it => currencies[it] = false)
                }
                $scope.query = {
                    bankTransferCode: "",
                    pending: true,
                    limit: 20,
                    statuses: {
                        PENDING: true,
                        PROCESSING: false,
                        APPROVED: false,
                        DECLINED: false,
                        PARTIALLY_PAID: false,
                        PAID: false,
                        FAILED: false,
                        CANCELLED: false,
                    },
                    isABA: null,
                    currencies: currencies
                };
                $scope.overrideKeys()
            };
            $scope.reset();

            $scope.search = function () {
                paginationService.resetPage($scope.queryKey);
                paginationService.pageQuery(getWithdrawals, $scope.queryKey);
            }


            function queryParams() {
                const query = {
                    ...$scope.query,
                    minimumPayout: $scope.query.minimumPayout ? $scope.query.minimumPayout * 100 : null,
                    maximumPayout: $scope.query.maximumPayout ? $scope.query.maximumPayout * 100 : null,
                    minimumWinnings: $scope.query.minimumWinnings ? $scope.query.minimumWinnings * 100 : null,
                    maximumWinnings: $scope.query.maximumWinnings ? $scope.query.maximumWinnings * 100 : null
                };
                query.marketId = $scope.marketId
                cacheService.registerObject($scope.queryKey, query)
                const queryParams = queryService.getQueryString(query, $scope.key);
                return queryParams;
            }


            let getWithdrawals = function() {
                return searchService.get("withdrawals" + queryService.getQueryString($scope.query, $scope.queryKey)).then(function (response) {
                    $scope.withdrawals = response.data.result;
                    paginationService.setPage($scope.queryKey, paginationService.buildPage(response));
                });
            }

            $scope.btnPress = function (keyEvent) {
                if (keyEvent.which === 13)
                    $scope.search();
            }
        }
    };
});
